import { Heading } from '@/components/ui/heading'
import { AppTooltip } from '@components/AppTooltip'
import SetupDuration from '@components/SetupDuration'
import SetupAttributes from '@components/SetupPotential'
import SetupRRR from '@components/SetupRRR'
import type { Setup } from '@hvf/contracts'
import { Show } from 'solid-js'
import { Flex, Grid } from 'styled-system/jsx'
import { promptTooltipClass } from '../../promptTooltipClass'
import SpecificationBadge from '../../SpecificationBadge'
import StageBadge from '../../StageBadge'

export default function (props: { setup?: Setup }) {
  return (
    <Show when={props.setup}>
      <Grid
        columnGap='14px'
        rowGap='6px'
        gridTemplateColumns='minmax(0, 1fr) auto'
        borderY='solid 1px'
        py='8px'
        borderColor='bg.subtle'
      >
        <Grid
          gap='6px'
          alignItems="center"
          justifyItems='start'
          minWidth={0}
        >
          <StageBadge patternStage={props.setup?.stage} wrap />
          <SpecificationBadge patternSpecification={props.setup?.pattern_specification} wrap />
        </Grid>
        <Grid
          gap='6px'
          alignItems="center"
          justifyItems='end'>
          <Flex
            gap='12px'
            alignItems='baseline'
          >
            <AppTooltip
              delay={900}
              content='Timeframe'
              contentClass={promptTooltipClass}
            >
              <SetupDuration setup={props.setup} />
            </AppTooltip>
            <AppTooltip
              delay={900}
              content='Risk Reward Ratio'
              contentClass={promptTooltipClass}
            >
              <Flex
                gap='1'
                alignItems='baseline'
              >
                <Heading
                  fontSize='10px'
                  fontWeight='600'
                  letterSpacing='.08em'
                  textTransform='uppercase'
                  color='editorialInk3'
                >
                  RRR
                </Heading>
                <SetupRRR setup={props.setup} />
              </Flex>
            </AppTooltip>
          </Flex>

          <SetupAttributes setup={props.setup} />
        </Grid>
      </Grid>
    </Show>
  )
}
